module.exports = __webpack_public_path__ + "static/media/team5.4feec7bc.png";